// Types
import ZoomPopupPanelSection from '../../workspace/header/currentBoardHeader/view/ZoomPopupPanelSection';
import { ViewUtilType } from '../../workspace/header/currentBoardHeader/view/ViewUtil';

/**
 * Because we need to update the ZoomPopupPanelSection and ViewUtil using vanilla JS, for performance reasons,
 * and they're in a completely separate part of the DOM to the ZoomCanvas, we need a way to share references
 * to the components with the ZoomCanvas.
 */
const createZoomComponentSingleton = () => {
    let zoomPopupPanelInstance: ZoomPopupPanelSection | null = null;
    let viewUtilInstance: ViewUtilType | null = null;

    const getZoomPopupPanelInstance = (): ZoomPopupPanelSection | null => zoomPopupPanelInstance;

    const setZoomPopupPanelInstance = (panelInstance: ZoomPopupPanelSection) => {
        zoomPopupPanelInstance = panelInstance;
    };
    const removeZoomPopupPanelInstance = () => {
        zoomPopupPanelInstance = null;
    };

    const getViewUtilInstance = (): ViewUtilType | null => viewUtilInstance;
    const removeViewUtilInstance = () => {
        viewUtilInstance = null;
    };

    const setViewUtilInstance = (utilInstance: ViewUtilType) => {
        viewUtilInstance = utilInstance;
    };

    return {
        getZoomPopupPanelInstance,
        setZoomPopupPanelInstance,
        removeZoomPopupPanelInstance,
        getViewUtilInstance,
        setViewUtilInstance,
        removeViewUtilInstance,
    };
};

const zoomComponentSingleton = createZoomComponentSingleton();

export default zoomComponentSingleton;
